import src from "IMAGE";
export default { src, width: 698, height: 632, blurWidth: 0, blurHeight: 0};
